import MyService from '../../service';
import MyUtil from '../../MyUtil';

const VehicleDetailApi = {
  getAll: async (part_id) => {
    let list = null;
    await MyService.getRequestData('/vehicle-detail-part/get-by-partner', {
      part_id,
    })
      .then((result) => (list = result.data))
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return list;
  },
  getOptions: async (options) => {
    let list = null;
    await MyService.getRequestData(
      '/vehicle-detail-part/get-by-options',
      options
    )
      .then((result) => (list = result.data))
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return list;
  },
  getAvailable: async (options) => {
    let list = null;
    if (!options.part_id || !options.book_rent || !options.book_retn) {
      return {
        code: 'error',
        message: 'Dữ liệu không đúng, vui lòng kiểm tra lại',
      };
    }
    await MyService.getRequestData('/vehicle-detail-part/available', options)
      .then((result) => (list = result))
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return list;
  },
  update: async (options) => {
    let value = null;
    if (!options.vhc_detl_part_id || !options.vhc_part_id) {
      alert('Đã xảy ra lỗi, vui lòng thử lại sau');
      return {
        code: 'error',
        message: 'Dữ liệu không đúng, vui lòng kiểm tra lại',
      };
    }
    let opt = {
      vhc_detl_part_id: options.vhc_detl_part_id,
      vhc_img: options.vhc_img,
      vhc_lcse_plate: options.vhc_lcse_plate,
      vhc_hide: options.vhc_hide,
      vhc_detl_part_name: options.vhc_detl_part_name,
      vhc_part_id: options.vhc_part_id,
    };
    opt = MyUtil.clean(opt);
    await MyService.putRequestData('/vehicle-detail-part', opt)
      .then((result) => {
        value = result;
        if (result.code == 'success') alert('Sửa xe thành công');
        else alert(`Lỗi ${result.message}`);
      })
      .catch((err) => {
        console.log(err);
      });
    return value;
  },
  hideVehicle: async (options) => {
    const result = null;
    if (!options.vhc_detl_part_id) {
      alert('Dữ liệu không đúng, vui lòng thử lại sau');
      return;
    }
    const opt = {
      vhc_hide: options.vhc_hide,
      vhc_detl_part_id: options.vhc_detl_part_id,
    };
    await MyService.putRequestData('/vehicle-detail-part', opt)
      .then((result) => (result = result.data))
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return result;
  },
  deleteVehicle: async (vhc_detl_part_id, vhc_part_id) => {
    let value = null;
    if (!vhc_detl_part_id || !vhc_part_id) {
      alert('Dữ liệu không đúng, vui lòng thử lại sau');
      return;
    }
    const opt = {
      vhc_detl_part_id,
      vhc_part_id,
    };
    await MyService.putRequestData('/vehicle-detail-part/delete', opt)
      .then((result) => (value = result))
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return value;
  },
  deleteListVehicle: async (vhc_detl_part_id, vhc_part_id) => {
    const result = null;
    if (!vhc_detl_part_id || !Array.isArray(vhc_detl_part_id) || !vhc_part_id) {
      alert('Dữ liệu không đúng, vui lòng thử lại sau');
      return;
    }
    const opt = {
      vhc_detl_part_id,
      vhc_part_id,
    };
    await MyService.putRequestData('/vehicle-detail-part/delete-list', opt)
      .then((result) => (result = result.data))
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return result;
  },
  create: async (options) => {
    let value;
    if (
      !options.vhc_part_id ||
      !options.vhc_detl_part_name ||
      !options.vhc_part_name
    ) {
      alert('Đã xảy ra lỗi, vui lòng thử lại sau');
      return;
    }

    await MyService.postRequestData('/vehicle-detail-part', options)
      .then((result) => {
        value = result.data;
        alert('Thêm xe thành công');
      })
      .catch((err) => alert('Đã có lỗi xảy ra! Vui lòng thử lại sau!'));
    return value;
  },
};

export default VehicleDetailApi;
